import { render, staticRenderFns } from "./colored-products-list-pagination.vue?vue&type=template&id=50238938&scoped=true"
import script from "./colored-products-list-pagination.vue?vue&type=script&lang=js"
export * from "./colored-products-list-pagination.vue?vue&type=script&lang=js"
import style0 from "./colored-products-list-pagination.vue?vue&type=style&index=0&id=50238938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50238938",
  null
  
)

export default component.exports